import { LANGUAGE } from '@/types/commonConst';

import type { MessageMap } from '..';

export const feedbackMessages = {
  CATEGORY_MUST_BE_SELECTED: {
    [LANGUAGE.EN]: 'At least one category must be selected.',
  },
  SENTIMENT_DETAIL: {
    [LANGUAGE.EN]: 'All of the sentiments in the feedback.',
  },
  SENTIMENT: {
    [LANGUAGE.EN]: 'The most prevailing sentiment in the feedback.',
  },
  ENDING_SENTIMENT: {
    [LANGUAGE.EN]: 'The last sentiment customer ended the conversation with.',
  },
} as const satisfies MessageMap;
